import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { motion } from 'framer-motion';
interface DarkModeToggleProps {
  isDark: boolean;
  onToggle: () => void;
}
export function DarkModeToggle({
  isDark,
  onToggle
}: DarkModeToggleProps) {
  return <button onClick={onToggle} className="relative w-14 h-7 bg-gray-200 dark:bg-gray-700 rounded-full p-1 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-[#00D084] focus:ring-offset-2 dark:focus:ring-offset-gray-900" aria-label="Toggle dark mode" data-id="element-18">
      <motion.div className="w-5 h-5 bg-white dark:bg-gray-900 rounded-full shadow-md flex items-center justify-center" animate={{
      x: isDark ? 24 : 0
    }} transition={{
      type: 'spring',
      stiffness: 500,
      damping: 30
    }} data-id="element-19">
        {isDark ? <Moon className="w-3 h-3 text-[#00D084]" data-id="element-20" /> : <Sun className="w-3 h-3 text-yellow-500" data-id="element-21" />}
      </motion.div>
    </button>;
}